import { QueryObserverOptions, useQuery } from 'react-query';

import FunctionKey from 'constants/functionKey';
import { useDlVaultContract } from 'clients/contracts/hooks';
import getNetworkRewardRecordDetailed, {
  GetNetworkRewardRecordDetailedInput,
  GetNetworkRewardRecordDetailedOutput,
} from '.';

type TrimmedGetNetworkRewardRecordDetailedInput = Omit<GetNetworkRewardRecordDetailedInput, 'dlVaultContract'>;

export type UseGetNetworkRewardRecordDetailedQueryKey = [
  FunctionKey.GET_NETWORK_REWARD_RECORD_DETAILED,
  TrimmedGetNetworkRewardRecordDetailedInput,
];

type Options = QueryObserverOptions<
  GetNetworkRewardRecordDetailedOutput,
  Error,
  GetNetworkRewardRecordDetailedOutput,
  GetNetworkRewardRecordDetailedOutput,
  UseGetNetworkRewardRecordDetailedQueryKey
>;

const useGetNetworkRewardRecordDetailed = (
  input: TrimmedGetNetworkRewardRecordDetailedInput,
  options?: Options,
) => {
  const dlVaultContract = useDlVaultContract();

  return useQuery(
    [FunctionKey.GET_NETWORK_REWARD_RECORD_DETAILED, input],
    () => getNetworkRewardRecordDetailed({ dlVaultContract, ...input }),
    options,
  );
};

export default useGetNetworkRewardRecordDetailed; 